<!--
 * @Author: weijinpeng jinpeng.wei@ctx.sg
 * @LastEditors: weijinpeng jinpeng.wei@ctx.sg
 * @Date: 2022-11-21 19:29:48
 * @LastEditTime: 2022-11-22 16:08:46
 * @Description: 
-->
<template>
   <div class="menu_logo mg" >
        <div class="menu_logo_icon">
            <img class="logo" v-if="!isBool" src="@/assets/img/mvgx_loco.png" alt="">
            <img class="logos" v-else src="@/assets/img/logo_zeepson.png" alt="">
        </div>
        <a-divider style="border-color: #00142a59"/>
   </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
export default {
    name: 'layoutLogo',
    setup() {
        const data = reactive({
            isBool:false,
            url:[
                {
                    key:"message.cnri-tuv.com",//国内测试环境
                },
                {
                    key:"www.cnri-tuv.zeepson.com",//国内产品环境
                },
            ]
        })
        //验证图片
        const changeImage = () => {
            let name = location.hostname
            for(let i = 0 ; i < data.url.length; i++){
                if(name == data.url[i].key){
                    data.isBool = true
                }else{
                    data.isBool = false
                }
            }
            console.log(123123,name,data.isBool)
        }
        onBeforeMount(() => {
            changeImage()
        })
        onMounted(() => {})
        return {
            ...toRefs(data),
        }
    },
}
</script>
<style scoped lang='less'>
.mg{
    margin: 35px 25px 0 25px;
}
.mg_t{
    margin: 35px 0 0 0;
}
.menu_logo{
    .menu_logo_icon{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 30px;
        .shu{
            width: 1px;
            height: 17px;
            border: 1px solid rgba(0,20,42,0.35);
            margin: 0 10px;
        }
        .logo{
            width:179px;
            height: 34px;
        }
        .logos{
            width:125px;
            height: 28px;
        }
        .logo1{
            width: 94px;
            height: 19px;
        }
    }
    .ant-divider-horizontal{
        margin: 47px 0 8px 0;
    }
}
</style>